/**
 * Created by Kai.Niklas on 21.04.2016.
 */
export class Adresse {
    constructor(ansprechpartner, verein, strasse, plz, ort, email, telefon, land, id, state, ustid, adresszusatz = "", hatZollDisclaimer = false) {
        this.ansprechpartner = ansprechpartner;
        this.verein = verein;
        this.strasse = strasse;
        this.plz = plz;
        this.ort = ort;
        this.email = email;
        this.telefon = telefon;
        this.land = land;
        this.id = id;
        this.ustid = ""; // || ustid; //"" wird auch zu false ausgewertet!
        if (typeof (ustid) !== "undefined") {
            this.ustid = ustid;
        }
        this.state = ""; // || ustid; //"" wird auch zu false ausgewertet!
        if (typeof (state) !== "undefined") {
            this.state = state;
        }
        this.adresszusatz = adresszusatz;
        this.hatZollDisclaimer = hatZollDisclaimer;
    }
    static createAdresseFromServerData(adresseFromServer) {
        return new Adresse(adresseFromServer.ansprechpartner, adresseFromServer.verein, adresseFromServer.strasse, adresseFromServer.plz, adresseFromServer.ort, adresseFromServer.email, adresseFromServer.telefon, adresseFromServer.land, adresseFromServer.id, typeof (adresseFromServer.state) !== "undefined" ? adresseFromServer.state : "", typeof (adresseFromServer.ustid) !== "undefined" ? adresseFromServer.ustid : "", adresseFromServer.adresszusatz, typeof (adresseFromServer.zollDisclaimer) !== "undefined" && adresseFromServer.zollDisclaimer === "1");
    }
}
export class AdressDaten {
    constructor() {
        this.ansprechpartner = "";
        this.vorname = "";
        this.street = "";
        this.verein = "";
        this.plz = "";
        this.ort = "";
        this.tel = "";
        this.land = "";
        this.ustid = "";
        this.state = "";
        this.zusatz = "";
        this.geschlecht = "";
        this.adressTyp = "";
        this.isFirma = 0;
    }
}
//# sourceMappingURL=Adresse.js.map